export default "__VITE_ASSET__B77HR$TE__"